export const GET_BANKS = 'GET_BANKS';
export const GET_BALANCE_DELIVERYMAN = 'GET_BALANCE_DELIVERYMAN';
export const GET_BLOCKS_DELIVERYMAN = 'GET_BLOCKS_DELIVERYMAN';

export enum ENUM_OPTIONS_REASON_TO_BLOCK_TYPE {
  REJECTION_UPON_ARRIVAL = 'Rejeição após chegada',
  IMPROPER_BILLING = 'Cobrança indevida',
  DELAY_WITHOUT_JUSTIFICATION = 'Atraso sem justificativa',
  LOSS = 'Extravio',
  FAKE_FINISH = 'Finalização falsa',
  RETURN_OF_MACHINE_AND_MONEY = 'Devolução de maquineta e dinheiro',
  INACTIVITY = 'Inatividade',
}
